<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle11')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle11') }}</h1>
    <p>{{ $t('artText11-1') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Unleashing_Your_Inner_Design_Guru_with_Free_Furniture_Arrangement_Magic.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText11-2') }}</h2>
    <p>{{ $t('artText11-3') }}</p>
    <h2>{{ $t('artText11-4') }}</h2>
    <p>{{ $t('artText11-5') }}</p>
    <h2>{{ $t('artText11-6') }}</h2>
    <p>{{ $t('artText11-7') }}</p>
    <h2>{{ $t('artText11-8') }}</h2>
    <p>{{ $t('artText11-9') }}</p>
    <h2>{{ $t('artText11-10') }}</h2>
    <p>{{ $t('artText11-11') }}</p>
    <h2>{{ $t('artText11-12') }}</h2>
    <p>{{ $t('artText11-13') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Unleashing_Your_Inner_Design_Guru_with_Free_Furniture_Arrangement_Magic_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText11-14') }}</p>
    <p>{{ $t('artText11-15') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle11')}`,
  ogTitle: `${t('artSeoTitle11')}`,
  description: `${t('artSeoDesc11')}`,
  ogDescription: `${t('artSeoDesc11')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
